// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root___d0FM","title":"Header_title__1Xmmg","side":"Header_side__3dhKp"};